import { createComponentWrapperWithRef, ListItemButton, styled } from '@msdk/ui'

import { NovaSidebarItem, SidebarItem } from './SidebarItem'

export const MuiSidebarListItemButton = styled(ListItemButton, {
  shouldForwardProp: (prop) => prop !== 'level' && prop !== 'last' && prop !== 'open',
})<{
  last?: boolean
  level: number
  open?: boolean
}>`
  ${SidebarItem};

  margin-bottom: ${(props) => {
    if (props.open) return '4px'
    if (props.level === 0 && props.last) return 0
    return props.level === 0 ? '8px' : '4px'
  }};
  padding-top: ${(props) => {
    return props.level === 0 ? '8px' : '4px'
  }};
  padding-bottom: ${(props) => {
    return props.level === 0 ? '8px' : '4px'
  }};
`

export const NovaSidebarListItemButton = styled(ListItemButton, {
  shouldForwardProp: (prop) => prop !== 'level' && prop !== 'last' && prop !== 'open',
})<{
  last?: boolean
  level: number
  open?: boolean
}>`
  ${NovaSidebarItem};

  margin-bottom: ${(props) => {
    if (props.open) return '4px'
    if (props.level === 0 && props.last) return 0
    return props.level === 0 ? '8px' : '4px'
  }};
  padding-top: ${(props) => {
    return props.level === 0 ? '8px' : '4px'
  }};
  padding-bottom: ${(props) => {
    return props.level === 0 ? '8px' : '4px'
  }};
`

export const SidebarListItemButton = createComponentWrapperWithRef(
  {
    mui: MuiSidebarListItemButton,
    nova: NovaSidebarListItemButton,
  },
  'ButtonBase',
)
